/* eslint-disable no-unused-vars */

import Swiper from 'swiper/swiper-bundle';

document.addEventListener('DOMContentLoaded', function () {
  var postsData = [];
  var currentIndex = 0;

  var dataScript = document.querySelector('.tl-posts-data');
  if (dataScript) {
    try {
      postsData = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Timeline data parse error:', e);
    }
  }

  var swiper = new Swiper('.timelineSwiperV2', {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 0,
    grabCursor: true,
    keyboard: { enabled: true },
    breakpoints: {
      480: { slidesPerView: 1.5, slidesPerGroup: 1, spaceBetween: 0 },
      640: { slidesPerView: 2.5, slidesPerGroup: 2, spaceBetween: 0 },
      768: { slidesPerView: 5, slidesPerGroup: 4, spaceBetween: 0 },
      1536: { slidesPerView: 5.25, slidesPerGroup: 5, spaceBetween: 0 },
    },
    pagination: {
      el: '.tl-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.tl-button-next',
      prevEl: '.tl-button-prev',
    },
  });

  // --- Popup ---
  var popup     = document.getElementById('tlPopup');
  var popupImg  = document.getElementById('tlPopupImage');
  var popupTitle = document.getElementById('tlPopupTitle');
  var popupText  = document.getElementById('tlPopupText');

  if (!popup) return;

  function openPopup(index) {
    var post = postsData[index];
    if (!post) return;

    currentIndex = index;
    popupImg.src       = post.image_url || '';
    popupImg.alt       = post.image_alt || '';
    popupImg.style.display = post.image_url ? '' : 'none';
    popupTitle.textContent = post.title || '';
    popupText.innerHTML    = post.content || '';

    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  // Open on .timeline-card__image click (only if not dragging)
  document.querySelectorAll('.timeline-card__image').forEach(function (imageEl) {
    imageEl.addEventListener('click', function () {
      if (swiper.allowClick === false) return;
      var slide = imageEl.closest('.timeline-card');
      if (!slide) return;
      var index = parseInt(slide.dataset.index, 10);
      if (!isNaN(index)) openPopup(index);
    });

    imageEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        imageEl.click();
      }
    });
  });

  popup.querySelector('.tl-popup__close').addEventListener('click', closePopup);

  popup.querySelector('.tl-popup__prev').addEventListener('click', function () {
    openPopup((currentIndex - 1 + postsData.length) % postsData.length);
  });

  popup.querySelector('.tl-popup__next').addEventListener('click', function () {
    openPopup((currentIndex + 1) % postsData.length);
  });

  // Close on backdrop click
  popup.addEventListener('click', function (e) {
    if (e.target === popup) closePopup();
  });

  // Close on Escape, navigate popup with arrow keys
  document.addEventListener('keydown', function (e) {
    if (popup.hasAttribute('hidden')) return;
    if (e.key === 'Escape') closePopup();
    if (e.key === 'ArrowLeft') openPopup((currentIndex - 1 + postsData.length) % postsData.length);
    if (e.key === 'ArrowRight') openPopup((currentIndex + 1) % postsData.length);
  });
});



// WEBPACK FOOTER //
// ./scripts/block-timeline-slider-v2.js